import { render, staticRenderFns } from "./OfficialInviteCode.vue?vue&type=template&id=94794ac2&scoped=true"
import script from "./OfficialInviteCode.vue?vue&type=script&lang=js"
export * from "./OfficialInviteCode.vue?vue&type=script&lang=js"
import style0 from "./OfficialInviteCode.vue?vue&type=style&index=0&id=94794ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94794ac2",
  null
  
)

export default component.exports